module.exports = __webpack_public_path__ + "img/empty_template.fec80d28.png";